import React, { forwardRef, useContext, useId, useState } from "react";
import styled from "styled-components";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import classNames from "classnames";
import playCircleIcon from "../../icons/play-circle.svg";
import Picture from "../Picture";
import YoutubeModal from '../Modals/YoutubeModal';
import ModalContext from "../../context/ModalContext";
import { getImagePath } from '../../utilities/path';

export interface IVideoPullquoteProps extends IEditableProps, IStyledProps {
    videoId: string;
    src: string;
    alt: string;
    mute: boolean;
    autoPlay: boolean;
    captions: boolean;
    showPullquote: boolean;
    cmsId?: string;
    editorClassObj?: any;
    children;
}

const Video = forwardRef((props: IVideoPullquoteProps, ref: any) => {
    const { children, editorClassObj, className, cmsId, videoId, src, alt, mute, autoPlay, captions, showPullquote } = props;
    const renderPullquote = (children && showPullquote);
    const { openModal } = useContext(ModalContext);
    const uniqueModalId = useId();

    return (
        <div data-id={cmsId} ref={ref} className={classNames(className, editorClassObj, {"pb-0": !renderPullquote})}>
            <div className="w-100 position-relative">
                <div
                    className={classNames("thumbnail position-relative h-100 overflow-hidden rounded-lg", {
                        "w-100": !renderPullquote,
                        "pe-none": !!cmsId || !videoId
                    })}
                    onClick={() => videoId && openModal(uniqueModalId)}
                >
                    <Picture loading="lazy" src={getImagePath(src) || `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`} alt={alt} className="w-100 h-100 image" />
                    { videoId && <span className="play-button position-absolute d-inline-block" /> }
                </div>

                {renderPullquote &&
                    React.Children.map(children, child => {
                        if (typeof child === "object") {
                            return React.cloneElement(child, { className: classNames("pullquote") })
                        }
                    })
                }
                { videoId &&
                    <YoutubeModal
                        videoId={videoId}
                        autoPlay={autoPlay}
                        subtitles={captions}
                        mute={mute}
                        modalId={uniqueModalId}
                    />
                }
            </div>
        </div>
    )
});

export default styled(Video)`
    padding-bottom: 20px;

    .thumbnail {
        width: 75%;
        cursor: pointer;

        &.pe-none {
            pointer-events: none;
        }
        .image {
            min-height: 200px;
            transition: transform 0.4s;
        }
        &:hover {
            .image {
                transform: scale(1.03, 1.03);
            }
        }
        .play-button {
            background: transparent url(${playCircleIcon}) center center no-repeat;
            background-size: cover;
            width: 4rem;
            height: 4rem;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }

    .pullquote {
        position: absolute;
        width: 50%;
        right: 0;
        bottom: -20px;
        margin-left: -25%;
    }

    @media(max-width: 1200px){
        .pullquote {
            width: 70%;
            bottom: -20px;
            margin-left: -35%;
        }
    }

    @media(max-width: 992px) {
        padding-bottom: 0;

        .thumbnail {
            width: 100%;
        }

        .pullquote {
            position: static;
            width: 100%;
            min-height: auto;
            margin: 1rem 0 0;
        }
    }
`;